module.exports = __webpack_public_path__ + "media/voiceOver_02.6ea7bf00.aac";